import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';

export enum SpaceStateTypes {
  MoveObjectToSpace = 'spaces.moveObjectToSpace',
}

export enum SpaceRequestTypes {
  CreateSpaceRequest = 'spaces.create.request',
  CreateSpaceSuccess = 'spaces.create.success',
  CreateSpaceFailure = 'spaces.create.failure',
  GetSpaceRequest = 'spaces.get.request',
  GetSpaceSuccess = 'spaces.get.success',
  GetSpaceFailure = 'spaces.get.failure',
  GetDefaultSpaceRequest = 'spaces.getDefault.request',
  GetDefaultSpaceSuccess = 'spaces.getDefault.success',
  GetDefaultSpaceFailure = 'spaces.getDefault.failure',
  GetAllSpacesRequest = 'spaces.getAll.request',
  GetAllSpacesSuccess = 'spaces.getAll.success',
  GetAllSpacesFailure = 'spaces.getAll.failure',
  UpdateSpaceRequest = 'spaces.updateSpace.request',
  UpdateSpaceSuccess = 'spaces.updateSpace.success',
  UpdateSpaceFailure = 'spaces.updateSpace.failure',
  DeleteSpaceRequest = 'spaces.deleteSpace.request',
  DeleteSpaceSuccess = 'spaces.deleteSpace.success',
  DeleteSpaceFailure = 'spaces.deleteSpace.failure',

  GetSpaceCardViewRequest = 'spaces.getCardView.request',
  GetSpaceCardViewSuccess = 'spaces.getCardView.success',
  GetSpaceCardViewFailure = 'spaces.getCardView.failure',
  GetLibraryViewRequest = 'spaces.getLibraryView.request',
  GetLibraryViewSuccess = 'spaces.getLibraryView.success',
  GetLibraryViewFailure = 'spaces.getLibraryView.failure',

  CreateSectionRequest = 'spaces.createSection.request',
  CreateSectionSuccess = 'spaces.createSection.success',
  CreateSectionFailure = 'spaces.createSection.failure',
  DuplicateSectionRequest = 'spaces.duplicateSection.request',
  DuplicateSectionSuccess = 'spaces.duplicateSection.success',
  DuplicateSectionFailure = 'spaces.duplicateSection.failure',
  UpdateSectionRequest = 'spaces.updateSection.request',
  UpdateSectionSuccess = 'spaces.updateSection.success',
  UpdateSectionFailure = 'spaces.updateSection.failure',
  DeleteSectionRequest = 'spaces.deleteSection.request',
  DeleteSectionSuccess = 'spaces.deleteSection.success',
  DeleteSectionFailure = 'spaces.deleteSection.failure',
  MoveSectionRequest = 'spaces.moveSection.request',
  MoveSectionSuccess = 'spaces.moveSection.success',
  MoveSectionFailure = 'spaces.moveSection.failure',

  CreateCardRequest = 'spaces.createCard.request',
  CreateCardSuccess = 'spaces.createCard.success',
  CreateCardFailure = 'spaces.createCard.failure',
  UpdateCardRequest = 'spaces.updateCard.request',
  UpdateCardSuccess = 'spaces.updateCard.success',
  UpdateCardFailure = 'spaces.updateCard.failure',
  DeleteCardRequest = 'spaces.deleteCard.request',
  DeleteCardSuccess = 'spaces.deleteCard.success',
  DeleteCardFailure = 'spaces.deleteCard.failure',
  MoveCardRequest = 'spaces.moveCard.request',
  MoveCardSuccess = 'spaces.moveCard.success',
  MoveCardFailure = 'spaces.moveCard.failure',

  GetSpacesSidebarViewRequest = 'spaces.getSpacesSidebarView.request',
  GetSpacesSidebarViewSuccess = 'spaces.getSpacesSidebarView.success',
  GetSpacesSidebarViewFailure = 'spaces.getSpacesSidebarView.failure',
  GetPersonalizedSidebarRequest = 'spaces.getPersonalizedSidebar.request',
  GetPersonalizedSidebarSuccess = 'spaces.getPersonalizedSidebar.success',
  GetPersonalizedSidebarFailure = 'spaces.getPersonalizedSidebar.failure',
  AddSidebarSpaceRequest = 'spaces.addSidebarSpace.request',
  AddSidebarSpaceSuccess = 'spaces.addSidebarSpace.success',
  AddSidebarSpaceFailure = 'spaces.addSidebarSpace.failure',
  RemoveSidebarSpaceRequest = 'spaces.removeSidebarSpace.request',
  RemoveSidebarSpaceSuccess = 'spaces.removeSidebarSpace.success',
  RemoveSidebarSpaceFailure = 'spaces.removeSidebarSpace.failure',

  MoveObjectRequest = 'spaces.moveObject.request',
  MoveObjectSuccess = 'spaces.moveObject.success',
  MoveObjectFailure = 'spaces.moveObject.failure',
  MoveObjectsRequest = 'spaces.moveObjects.request',
  MoveObjectsSuccess = 'spaces.moveObjects.success',
  MoveObjectsFailure = 'spaces.moveObjects.failure',
  LinkObjectRequest = 'spaces.linkObject.request',
  LinkObjectSuccess = 'spaces.linkObject.success',
  LinkObjectFailure = 'spaces.linkObject.failure',
  BulkLinkObjectsRequest = 'spaces.bulkLinkObjects.request',
  BulkLinkObjectsSuccess = 'spaces.bulkLinkObjects.success',
  BulkLinkObjectsFailure = 'spaces.bulkLinkObjects.failure',
  DereferenceObjectRequest = 'spaces.dereferenceObject.request',
  DereferenceObjectSuccess = 'spaces.dereferenceObject.success',
  DereferenceObjectFailure = 'spaces.dereferenceObject.failure',
  BulkDereferenceObjectsRequest = 'spaces.bulkDereferenceObjects.request',
  BulkDereferenceObjectsSuccess = 'spaces.bulkDereferenceObjects.success',
  BulkDereferenceObjectsFailure = 'spaces.bulkDereferenceObjects.failure',
  GetObjectSpaceRequest = 'spaces.objectSpace.request',
  GetObjectSpaceSuccess = 'spaces.objectSpace.success',
  GetObjectSpaceFailure = 'spaces.objectSpace.failure',

  SetSpacesEnabledRequest = 'spaces.setEnabled.request',
  SetSpacesEnabledSuccess = 'spaces.setEnabled.success',
  SetSpacesEnabledFailure = 'spaces.setEnabled.failure',
}

export type OwnedObjectType = Exclude<
  ObjectType,
  | ObjectType.ELEMENT
  | ObjectType.EVENT
  | ObjectType.API_EVENT
  | ObjectType.PAGE_TYPE
  | ObjectType.SPACE
  | ObjectType.TEXT
  | ObjectType.UNKNOWN
  | ObjectType.SPEC_OBJECT_MAPPING
  | ObjectType.SPEC_PROPERTY_MAPPING
  | ObjectType.PROPERTY
>;

/**
 * Type guard for checking if an ObjectType is an OwnedObjectType.
 * @param objectType object to check
 * @returns true if the object is an OwnedObjectType, false otherwise
 */
export const isOwnedObjectType = (
  objectType: ObjectType | undefined,
): objectType is OwnedObjectType => {
  if (!objectType) return false;
  switch (objectType) {
    case ObjectType.ELEMENT:
    case ObjectType.EVENT:
    case ObjectType.PAGE_TYPE:
    case ObjectType.SPACE:
    case ObjectType.TEXT:
    case ObjectType.SPEC_OBJECT_MAPPING:
      return false;
    default:
      return true;
  }
};
